package pl.finn.forms.utils.validation

object ValidationUtils {

  fun validateAccountNumber(accountNumber: String?): String? { //todo ezw move there using same fun in fk02
    val countryCodeCoded = "2521" // PL (P - 25, L - 21)
    if (accountNumber == null) {
      return "Nie wpisano numeru konta"
    }

    //1. wywalić biale znaki
    val accountNumberWithoutSpaces = accountNumber
      .replace(" ", "")
      .replace("_", "")
      .replace("-", "")

    //2. if(dł!=26) zla dlugosc
    if (accountNumberWithoutSpaces.length != 26) {
      return "Zła długość"
    }

    //3. |skladamy nr konta bez 2 cyfr od lewej|kod kraju z numerku(2521)|2 cyfry kontrolne z nr konta
    val temp = (accountNumberWithoutSpaces.substring(2) + countryCodeCoded + accountNumberWithoutSpaces.substring(0, 2))
    //4. mod 97 == 1 //z powodu, że liczba nie mieści się w zakresie obliczenie modulo 97 odbywa się etapowo na mniejszych fragmentach
    val temp2 = temp.substring(0, 10).toLong() % 97L
    val temp3 = (temp2.toString() + temp.substring(10, 20)).toLong() % 97L
    val temp4 = (temp3.toString() + temp.substring(20)).toLong() % 97L
    if (temp4 != 1L) {
      return "Błąd w numerze rachunku"
    }

    return null
  }
}